import { FaMedal } from "react-icons/fa";

const PrizeDistribution = ({ prizes = [] }) => {
  return (
    // <div className="col-md-4 col-12 mb-4">
      <div className="rounded border shadow-sm bg-dark text-light border-primary">
        <div className="p-4">
          <h5 className="text-light fw-bold mb-3">Prize Distribution</h5>

          <div className="row">
            {prizes.map((prize, index) => (
              <div key={index} className="col-12 col-md-4 mb-3 ">
                <div className="d-flex align-items-center p-3 bg-secondary rounded h-100 hover-card">
                  <FaMedal
                    size={24}
                    className={
                      index === 0
                        ? "text-warning me-2"
                        : index === 1
                        ? "text-muted me-2"
                        : "text-brown me-2"
                    }
                  />
                  <div>
                    <h6 className="mb-1 fw-bold">{prize.position}</h6>
                    <small className="text-light">{prize.reward}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    // </div>
  );
};

export default PrizeDistribution;
